// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__SfkPl","linkDestacado":"MenuLink_linkDestacado__NGYnS"};